import { BarLoader } from "react-spinners";

const CommonLoading = () => {
  return <BarLoader color="#1D8087" height={5} width={100} />;
};

export default CommonLoading;
